<template>
  <div id="news">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'news'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/portal/news/news/News.vue